import React, { FunctionComponent } from 'react';
import classNames from 'classnames';
import Logo, { LogoColor } from 'components/logo/logo';
import Page from 'components/page/page';
import PageContent from 'components/page/page-content';
import PageHeader from 'components/page/page-header';
import PageFooter from 'components/page/page-footer';
import FooterLinks, { FooterLinksProps } from 'components/footer-links/footer-links';
import SocialLinks, { SocialLink } from 'components/social-links/social-links';
import JoinHives, { JoinHivesProps } from 'components/join-hives/join-hives';

export type JoinHivesPageProps = JoinHivesProps & {
    footerLinks: FooterLinksProps['items'];
    socialLinks: SocialLink[];
    copyright: string;
};

const JoinHivesPage: FunctionComponent<JoinHivesPageProps> = (props) => {
    return (
        <div className={classNames('join-hives-page', { mobile: props.isMobile })}>
            <Page>
                <PageHeader>
                    <Logo
                        color={props.isMobile ? LogoColor.INHERITED : LogoColor.PRIMARY}
                        height={props.isMobile ? 44 : 50}
                    />
                </PageHeader>
                <PageContent>
                    <JoinHives {...props} />
                </PageContent>
                <PageFooter
                    links={<FooterLinks items={props.footerLinks} />}
                    socialLinks={<SocialLinks socialLinks={props.socialLinks} />}
                    copyright={props.copyright}
                />
            </Page>
        </div>
    );
};

export default JoinHivesPage;
